<template>
  <v-dialog
    v-model="show"
    width="600"
    content-class="deposit-info-dialog__content"
  >
    <div class="deposit-info-dialog__wrapper">
      <div class="deposit-info-dialog__header">
        <h2>How is the deposit calculated</h2>

        <v-icon class="pointer" @click="show = false">
          mdi-close
        </v-icon>
      </div>

      <send-egift-panel-deposit-info />
    </div>
  </v-dialog>
</template>

<script>
import panelVModel from '@/mixins/panelVModel'
import SendEgiftPanelDepositInfo from '../sendEgift/steps/SendEgiftPanelDepositInfo.vue'

export default {
  name: 'TheDepositInfoDialog',
  components: {
    SendEgiftPanelDepositInfo
  },
  mixins: [
    panelVModel
  ]
}
</script>

<style lang="scss" scoped>
.deposit-info-dialog {
  &__wrapper {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-height: 80vh;
    overflow-y: auto;
  }

  &__header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-family: 'Lato-Bold', sans-serif;
      font-size: 22px;
      line-height: 27px;
      color: #000;
      margin: 0;
    }
  }
}
</style>
